function Leg({ leg, eventId }) {
  return (
    <div
      key={`${eventId}-${leg.team}`}
      className="p-4 border-r border-zinc-800 last:border-r-0"
    >
      <div className="overline mb-1">PLACE AT</div>
      <div className="font-display text-lg text-white">{leg.book}</div>
      <div className="mono text-sm text-zinc-300 mt-3">
        {leg.team}{" "}
        <span className="neon-text">
          {leg.price > 0 ? `+${leg.price}` : leg.price}
        </span>
      </div>
      <div className="mt-3 flex justify-between mono text-sm">
        <span className="text-zinc-400">
          Stake <span className="text-white">${leg.stake}</span>
        </span>
        <span className="text-zinc-400">
          To win <span className="amber-text">${leg.to_win}</span>
        </span>
      </div>
    </div>
  );
}

export default function ArbCard({ arb }) {
  const commenceLabel = arb.commence_time
    ? new Date(arb.commence_time).toLocaleString()
    : "";
  return (
    <div
      data-testid={`arb-${arb.event_id}`}
      className="border border-[#00D4FF]/30 bg-[#00D4FF]/5 p-6"
    >
      <div className="flex flex-wrap justify-between items-start gap-4 mb-5">
        <div>
          <div className="font-display text-2xl text-white">{arb.matchup}</div>
          <div className="mono text-xs text-zinc-500 mt-1">
            {commenceLabel}
            {" · "}implied {arb.total_implied_pct}%
          </div>
        </div>
        <div className="text-right">
          <div className="overline">LOCKED PROFIT</div>
          <div className="font-display text-4xl neon-text">
            +${arb.guaranteed_profit}
          </div>
          <div className="mono text-xs amber-text">
            {arb.profit_pct}% ROI on ${arb.total_stake}
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-0 border border-zinc-800">
        {arb.stake_plan.map((leg) => (
          <Leg key={`${arb.event_id}-${leg.team}`} leg={leg} eventId={arb.event_id} />
        ))}
      </div>
    </div>
  );
}
